export class WebInclusaoDependenteTempADO {
    iD_PESSOA: number;
    iD_PESSOA_DEP: number;
    iD_STATUS: number;
}